/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataImportStatusEnum } from './DataImportStatusEnum';
import {
    DataImportStatusEnumFromJSON,
    DataImportStatusEnumFromJSONTyped,
    DataImportStatusEnumToJSON,
    DataImportStatusEnumToJSONTyped,
} from './DataImportStatusEnum';
import type { ImportTypeEnum } from './ImportTypeEnum';
import {
    ImportTypeEnumFromJSON,
    ImportTypeEnumFromJSONTyped,
    ImportTypeEnumToJSON,
    ImportTypeEnumToJSONTyped,
} from './ImportTypeEnum';

/**
 * Serializer for the DataImport model.
 * @export
 * @interface DataImport
 */
export interface DataImport {
    /**
     * 
     * @type {ImportTypeEnum}
     * @memberof DataImport
     */
    importType: ImportTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof DataImport
     */
    importParams?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DataImport
     */
    readonly id: string;
    /**
     * 
     * @type {DataImportStatusEnum}
     * @memberof DataImport
     */
    status?: DataImportStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof DataImport
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof DataImport
     */
    createdBy: number;
    /**
     * 
     * @type {any}
     * @memberof DataImport
     */
    readonly importErrors: any | null;
}



/**
 * Check if a given object implements the DataImport interface.
 */
export function instanceOfDataImport(value: object): value is DataImport {
    if ((!('importType' in (value as Record<string, any>)) && !('import_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['importType'] === undefined && (value as Record<string, any>)['import_type'] === undefined)) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('createdBy' in (value as Record<string, any>)) && !('created_by' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdBy'] === undefined && (value as Record<string, any>)['created_by'] === undefined)) return false;
    if ((!('importErrors' in (value as Record<string, any>)) && !('import_errors' in (value as Record<string, any>))) || ((value as Record<string, any>)['importErrors'] === undefined && (value as Record<string, any>)['import_errors'] === undefined)) return false;
    return true;
}

export function DataImportFromJSON(json: any): DataImport {
    return DataImportFromJSONTyped(json, false);
}

export function DataImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImport {
    if (json == null) {
        return json;
    }
    return {
        
        'importType': ImportTypeEnumFromJSON(json['import_type']),
        'importParams': json['import_params'] === undefined ? undefined : json['import_params'] === null ? null : json['import_params'],
        'id': json['id'],
        'status': json['status'] == null ? undefined : DataImportStatusEnumFromJSON(json['status']),
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'createdBy': json['created_by'],
        'importErrors': json['import_errors'],
    };
}

export function DataImportToJSON(json: any): DataImport {
    return DataImportToJSONTyped(json, false);
}

export function DataImportToJSONTyped(value?: Omit<DataImport, 'id'|'createdAt'|'importErrors'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'import_type': ImportTypeEnumToJSON(value['importType']),
        'import_params': value['importParams'],
        'status': DataImportStatusEnumToJSON(value['status']),
        'created_by': value['createdBy'],
    };
}

